import i18n from "../../../../constants/i18n";
import {
  ACTION_TAKEN_OPTIONS,
  ADMIN_AUDIT_PICKER_ENTRIES,
  EVENTS_LIMIT,
  EVENTS_LIMIT_REPORT,
  GENDER_OPTIONS,
  SUBSCRIPTION_OPTIONS
} from "../../../../constants/picker-entries-constants";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Date from "../../../../core/et3-input/et3-date";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getAuditStore from "../../../../stores/auditor-store/audit-store";
import getRootStore from "../../../../stores/core/root-store";
import React from "react";
import ET3Div from "../../../../core/et3-div";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";

const AuditForm = withLiteObserverAndTheme((props) => {
  const allAdmins = getRootStore().allAdmins.get();
  const isGettingEventsDisabled = getAuditStore().isGettingEventsDisabled();
  const enableCleanPool = getAuditStore().enableCleanPool.get();
  const { theme } = props;
  const { colors } = theme;

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("ADMIN")}
          options={allAdmins}
          value={getAuditStore().adminInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getAuditStore().setAdmin({ admin: value });
          }}
          onEnter={() => getAuditStore().getEvents()}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} right={0} left={30} />
        <Et3Picker
          label={i18n.get("TYPE")}
          options={ADMIN_AUDIT_PICKER_ENTRIES}
          value={getAuditStore().typeInputAudit.get()}
          onChoose={(type: TEt3PickerSingleValue) => {
            getAuditStore().setTypeInputAudit(type);
            if (type.value === "report") {
              getAuditStore().setLimitInput(EVENTS_LIMIT_REPORT[0]);
            } else {
              getAuditStore().setLimitInput(EVENTS_LIMIT[0]);
            }
          }}
          onEnter={() => getAuditStore().getEvents()}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} right={30} left={0} />
        <Et3Picker
          label={i18n.get("LIMIT")}
          options={
            getAuditStore().typeInputAudit.get().value === "report"
              ? EVENTS_LIMIT_REPORT
              : EVENTS_LIMIT
          }
          value={getAuditStore().limitInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getAuditStore().setLimitInput(value);
          }}
          onEnter={() => getAuditStore().getEvents()}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("SUBSCRIPTION")}
          options={SUBSCRIPTION_OPTIONS}
          value={getAuditStore().subscriptionInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getAuditStore().setSubscriptionInput(value);
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("GENDER")}
          options={GENDER_OPTIONS}
          value={getAuditStore().genderInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getAuditStore().setGenderInput(value);
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("ACTION_TAKEN")}
          options={ACTION_TAKEN_OPTIONS}
          value={getAuditStore().actionTakenInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getAuditStore().setActionTakenInput(value);
          }}
          onEnter={() => {}}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MIN")}
          dateInputObservable={getAuditStore().dateMinInput}
          isEnabled={true}
        />
        <Et3Margin top={0} bottom={0} right={0} left={30} />
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MAX")}
          dateInputObservable={getAuditStore().dateMaxInput}
          isEnabled={true}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={45}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Button
          onClick={async () => await getAuditStore().getEvents()}
          isEnabled={!isGettingEventsDisabled}
          size="LARGE"
          type="GET"
          text="GET"
        />
        <Et3Margin top={0} bottom={0} right={30} left={0} />
        <Et3Button
          onClick={async () => await getAuditStore().cleanAuditPool()}
          isEnabled={enableCleanPool}
          size="LARGE"
          type="REJECT"
          text="CLEAN_POOL"
        />
      </ET3Div>
    </React.Fragment>
  );
});
export default AuditForm;
